module.exports = __webpack_public_path__ + "media/images/sign-up-bg-img-00d94a9e2d2c64b8168c0f29e36be0a8.png";